import {AppState} from '../../index';
import {createSelector} from 'reselect';
import {AcceptorBranchResponsePayload, AcceptorResponsePayload} from '../../../shared/models/api';

export const acceptorsListSelector = (filter: (item: AcceptorBranchResponsePayload) => boolean = () => true) =>
  createSelector(
    (state: AppState) => state.acceptors.list,
    (items) => (items ? items.filter(filter) : items),
  );

export const acceptorsByIdSelector = (id: number) =>
  createSelector(
    (state: AppState) => state.acceptors.list?.find((item) => item.id === id),
    (item) => item as AcceptorResponsePayload,
  );

export const acceptorCategoriesSelector = () =>
  createSelector(
    (state: AppState) => state.acceptors.listAcceptorCategories,
    (item) => item,
  );

export const acceptorBranchesSelector = () =>
  createSelector(
    (state: AppState) => state.acceptors.acceptorBranches,
    (branches) => branches as AcceptorBranchResponsePayload[],
  );
